import styles from './WhiteSpace2.module.css';

import React from 'react'

export type WhiteSpaceProps = {
    height?: string;
}

const WhiteSpace2 = (props: WhiteSpaceProps) => {
  return (
    <div className={styles.white_Space} style={{ height: props.height ? props.height : '20dvh' }}></div>
  )
}

export default WhiteSpace2